// extracted by mini-css-extract-plugin
export default {"selectedQrIcon":"poster-editor-qr-content-background-panel-module__selectedQrIcon--f8j0s"};